// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"aea-breadcrumb_PageTitle__2Liz_","BackTitle":"aea-breadcrumb_BackTitle__2Gtd6","SubTitle":"aea-breadcrumb_SubTitle__2JmOg"};